import React from "react";
import { Box } from "@mui/material";

const MarqueeStrip = () => (
  <Box sx={{ py: 3, bgcolor: "#fff", mt: 4 }}>
    <Box className="marquee">
      <Box
        className="marquee-inner"
        sx={{ fontSize: { xs: "16px", sm: "20px", md: "34px" }, fontWeight: 600 }}
      >
        ✨ ALL-IN-ONE ✦ WATER MITIGATION ✦ PROFESSIONAL CLEANING ✦ HVAC MAINTAINENC & REPAIR ✦
        ROOFING SERVICES ✦ EMERGENCY SERVICES ✦ HOME REPAIR ✦ FACILITY MAINTENANCE ✨
      </Box>
    </Box>
  </Box>
);

export default MarqueeStrip;
